import { CommonUtilities } from "../../commonUtils";
import { Modal } from 'react-responsive-modal';
import React, { Suspense, useState, useEffect } from "react";
import Pagination from 'components/Common/newPagination';
import ClientProfileSevices from "./clientProfileServices";

export default function AuditTrail() {


    const [openFirst, setOpenFirst] = React.useState(false);

    let [Chronological, setChronological] = useState(true);
    const [ChronologicalListing, setChronologicalListing] = useState<any>([]);
    const [ChronologicalListingCreators, setChronologicalListingCreators] = useState<any>([]);

    let [contractMgt, setcontractMgt] = useState(false);
    const [contractMgtCount, setcontractMgtCount] = useState(0);
    const [contractMgtListing, setcontractMgtListing] = useState<any>([]);

    let [auditInvoice, setauditInvoice] = useState(false);
    const [auditInvoiceCount, setauditInvoiceCount] = useState(0);
    const [auditInvoiceListing, setauditInvoiceListing] = useState<any>([]);

    let [emailStatement, setemailStatement] = useState(false);
    const [emailStatementCount, setemailStatementCount] = useState(0);
    const [emailStatementListing, setemailStatementListing] = useState<any>([]);

    let [SuggestedPayment, setSuggestedPayment] = useState(false);
    const [SuggestedPaymentCount, setSuggestedPaymentCount] = useState(0);
    const [SuggestedPaymentListing, setSuggestedPaymentListing] = useState<any>([]);


    let [mechanical, setmechanical] = useState(false);
    const [mechanicalCount, setmechanicalCount] = useState(0);
    const [mechanicalListing, setmechanicalListing] = useState<any>([]);

    let [TrackManagement, setTrackManagement] = useState(false);
    const [TrackManagementCount, setTrackManagementCount] = useState(0);
    const [TrackManagementListing, setTrackManagementListing] = useState<any>([]);

    let [MetaData, setMetaData] = useState(false);
    const [MetaDataCount, setMetaDataCount] = useState(0);
    const [MetaDataListing, setMetaDataListing] = useState<any>([]);

    let [UserManagement, setUserManagement] = useState(false);
    const [UserManagementCount, setUserManagementCount] = useState(0);
    const [UserManagementListing, setUserManagementListing] = useState<any>([]);

    let [DataLoad, setDataLoad] = useState(false);
    const [DataLoadCount, setDataLoadCount] = useState(0);
    const [DataLoadListing, setDataLoadListing] = useState<any>([]);

    let [DataManagement, setDataManagement] = useState(false);
    const [DataManagementCount, setDataManagementCount] = useState(0);
    const [DataManagementListing, setDataManagementListing] = useState<any>([]);

    let [APIService, setAPIService] = useState(false);
    const [APIServiceCount, setAPIServiceCount] = useState(0);
    const [APIServiceListing, setAPIServiceListing] = useState<any>([]);

    let [System, setSystem] = useState(false);
    const [SystemCount, setSystemCount] = useState(0);
    const [SystemListing, setSystemListing] = useState<any>([]);


    const [searchFor, setsearchFor] = useState("");
    var payload = {
        "search": "none",
        "operation": "Update",
        "pageNumber": 1,
        "pageSize": 10,
        "searchDesc": "none"
    }

    const apiCall = (param: any) => {
        if (param === 1) {
            payload.search = searchFor.length > 0 ? searchFor : "";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setChronologicalListing(values) })
            payload.operation = "Create";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setChronologicalListingCreators(values) })
        } if (param === 2 && contractMgt) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "Contract";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setcontractMgtListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setcontractMgtCount(values) })

        } if (param === 3 && auditInvoice) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "none";
            payload.search = "Invoice";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setauditInvoiceListing(values) })

            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setauditInvoiceCount(values) })

        } if (param === 4 && emailStatement) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "Email Statement";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setemailStatementListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setemailStatementCount(values) })

        } if (param === 5 && SuggestedPayment) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "Suggested Payment";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setSuggestedPaymentListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setSuggestedPaymentCount(values) })

        } if (param === 6 && mechanical) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "Mechanical";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setmechanicalListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setmechanicalCount(values) })

        } if (param === 7 && TrackManagement) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "Track";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setTrackManagementListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setTrackManagementCount(values) })

        } if (param === 8 && UserManagement) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "User Management";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setUserManagementListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setUserManagementCount(values) })

        } if (param === 9 && MetaData) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "MetaData";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setMetaDataListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setMetaDataCount(values) })

        } if (param === 10 && DataLoad) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "DataLoad";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setDataLoadListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setDataLoadCount(values) })

        } if (param === 11 && DataManagement) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "DataManagement";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setDataManagementListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setDataManagementCount(values) })

        } if (param === 12 && APIService) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "iTunesAPIService";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setAPIServiceListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setAPIServiceCount(values) })

        } if (param === 13 && System) {
            payload.searchDesc = searchFor.length > 0 ? searchFor : "";
            payload.search = "System";
            payload.operation = "none";
            ClientProfileSevices.AuditTrailChronological(payload).then((values) => { setSystemListing(values) })
            ClientProfileSevices.AuditTrailCount(payload).then((values) => { setSystemCount(values) })

        }
    }

    const handlecontractMgt = (event: any) => {
        console.log(event)
        payload.pageNumber = event.pageNumber;
        payload.pageSize = event.pageSize;
        apiCall(event.indexType)
    }



    return (

        <div className="pull-left">
            <div className="pull-left" onClick={() => { setOpenFirst(true); apiCall(1); }}>
                <div className="box-primary ms text-center iconLogo pull-left  mrl">
                    <i className="box icon-line-chart"></i>
                    <span className="m0 pts ">Audit Trail</span>
                </div>
            </div>

            <Modal open={openFirst} onClose={() => setOpenFirst(false)} center>
                <div className="ws-12 box pbl">

                    <div className="box box-content">

                        <div className="box">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > Chronological Order </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => setChronological(!Chronological)}>
                                        <i className={Chronological === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {Chronological === true && <div className="box-content">
                                <div className="row-fluid ws-12">

                                    <div className="ws-6">
                                        <h1> Top 10 Modifications  </h1>
                                        <div className="table-responsive">
                                            {(ChronologicalListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                                <thead>
                                                    <tr>
                                                        <th>User</th>
                                                        <th>Description</th>
                                                        <th>Category</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ChronologicalListingCreators.map((value: any) => {
                                                        return (
                                                            <tr>
                                                                <td >{value.username}</td>
                                                                <td >{value.description}</td>
                                                                <td >{value.category}</td>
                                                                <td >{value.date}</td>
                                                            </tr>)
                                                    })}
                                                </tbody>
                                            </table>}
                                        </div>

                                        {(ChronologicalListing.length === 0) && <div className="alert alert-info" >No Data ModificationLog to display </div>}
                                    </div>
                                    <div className="ws-6 pll">
                                        <h1> Top 10 Creations  </h1>
                                        <div className="table-responsive">
                                            {(ChronologicalListing.length > 0) && <table className="table bgWhite tablePresentation">
                                                <thead>
                                                    <tr>
                                                        <th>User</th>
                                                        <th>Description</th>
                                                        <th>Category</th>
                                                        <th>Date</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {ChronologicalListing.map((value: any) => {
                                                        return (
                                                            <tr>
                                                                <td >{value.username}</td>
                                                                <td >{value.description}</td>
                                                                <td >{value.category}</td>
                                                                <td >{value.date}</td>
                                                            </tr>)
                                                    })}
                                                </tbody>
                                            </table>}
                                        </div>
                                        {(ChronologicalListing.length === 0) && <div className="alert alert-info" >No Data Creation Log to display</div>}
                                    </div>
                                </div>

                            </div>}

                        </div>

                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > Contract Management </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); contractMgt = !contractMgt; setcontractMgt(contractMgt); apiCall(2) }}>
                                        <i className={contractMgt === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {contractMgt === true && <div className="box-content">
                                <div className="form-format ws-12">

                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(2) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(2) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(contractMgtListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {contractMgtListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(contractMgtListing.length === 0) && <div className="alert alert-info" >No Contract Management Log to display  </div>}

                                        {
                                            (() => {
                                                if (contractMgtCount && contractMgtCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 2 } })} totalRow={contractMgtCount} /></div>
                                                }
                                            })()

                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>

                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > Invoice Audit </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); auditInvoice = !auditInvoice; setauditInvoice(auditInvoice); apiCall(3) }}>
                                        <i className={auditInvoice === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {auditInvoice === true && <div className="box-content">
                                <div className="form-format ws-12">

                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(3) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(3) }}> Refresh</a>
                                    </div>

                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(auditInvoiceListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {auditInvoiceListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(auditInvoiceListing.length === 0) && <div className="alert alert-info" >No Contract Management Log to display  </div>}

                                        {
                                            (() => {
                                                if (auditInvoiceCount && auditInvoiceCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 3 } })} totalRow={auditInvoiceCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>

                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > Email Statement </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); emailStatement = !emailStatement; setemailStatement(emailStatement); apiCall(4) }}>
                                        <i className={emailStatement === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {emailStatement === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(4) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(4) }}> Refresh</a>
                                    </div>

                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(emailStatementListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {emailStatementListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(emailStatementListing.length === 0) && <div className="alert alert-info" >No Contract Management Log to display  </div>}

                                        {
                                            (() => {
                                                if (emailStatementCount && emailStatementCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 4 } })} totalRow={emailStatementCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>

                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > Suggested Payment </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); SuggestedPayment = !SuggestedPayment; setSuggestedPayment(SuggestedPayment); apiCall(5) }}>
                                        <i className={SuggestedPayment === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {SuggestedPayment === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(5) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(5) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(SuggestedPaymentListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {SuggestedPaymentListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(SuggestedPaymentListing.length === 0) && <div className="alert alert-info" >No Contract Management Log to display  </div>}



                                        {
                                            (() => {
                                                if (SuggestedPaymentCount && SuggestedPaymentCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 5 } })} totalRow={SuggestedPaymentCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>

                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > Mechanical </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); mechanical = !mechanical; setmechanical(mechanical); apiCall(6) }}>
                                        <i className={mechanical === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {mechanical === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(6) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(6) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(mechanicalListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {mechanicalListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(mechanicalListing.length === 0) && <div className="alert alert-info" >No Contract Management Log to display  </div>}

                                        {
                                            (() => {
                                                if (mechanicalCount && mechanicalCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 6 } })} totalRow={mechanicalCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>

                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > Track Management </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); TrackManagement = !TrackManagement; setTrackManagement(TrackManagement); apiCall(7) }}>
                                        <i className={TrackManagement === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {TrackManagement === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(7) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(7) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(TrackManagementCount > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {TrackManagementListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(TrackManagementListing.length === 0) && <div className="alert alert-info" >No Contract Management Log to display  </div>}

                                        {
                                            (() => {
                                                if (TrackManagementCount && TrackManagementCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 7 } })} totalRow={TrackManagementCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>

                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > User Management </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); UserManagement = !UserManagement; setUserManagement(UserManagement); apiCall(8) }}>
                                        <i className={UserManagement === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {UserManagement === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(8) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(8) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(UserManagementListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {UserManagementListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(UserManagementListing.length === 0) && <div className="alert alert-info" >No User Management Log to display  </div>}

                                        {
                                            (() => {
                                                if (UserManagementCount && UserManagementCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 8 } })} totalRow={UserManagementListing} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>
                        {/* MetaData */}
                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > MetaData </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); MetaData = !MetaData; setMetaData(MetaData); apiCall(9) }}>
                                        <i className={MetaData === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {MetaData === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(9) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(9) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(MetaDataListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {MetaDataListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(MetaDataListing.length === 0) && <div className="alert alert-info" >No MetaData Log to display  </div>}

                                        {
                                            (() => {
                                                if (MetaDataCount && MetaDataCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 9 } })} totalRow={MetaDataCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>
                        {/* DataLoad */}
                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > DataLoad </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); DataLoad = !DataLoad; setDataLoad(DataLoad); apiCall(10) }}>
                                        <i className={DataLoad === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {DataLoad === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(10) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(10) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(DataLoadListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {DataLoadListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(DataLoadListing.length === 0) && <div className="alert alert-info" >No DataLoad Log to display  </div>}

                                        {
                                            (() => {
                                                if (DataLoadCount && DataLoadCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 10 } })} totalRow={DataLoadCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>

                        {/* DataManagement */}
                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > Data Management </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); DataManagement = !DataManagement; setDataManagement(DataManagement); apiCall(11) }}>
                                        <i className={DataManagement === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {DataManagement === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(11) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(11) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(DataManagementListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {DataManagementListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(DataManagementListing.length === 0) && <div className="alert alert-info" >No Data Managementt Log to display  </div>}

                                        {
                                            (() => {
                                                if (DataManagementCount && DataManagementCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 11 } })} totalRow={DataManagementCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>
                        {/* iTunes API Service */}
                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > iTunes API Service </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); APIService = !APIService; setAPIService(APIService); apiCall(12) }}>
                                        <i className={APIService === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {APIService === true && <div className="box-content">
                                <div className="form-format ws-12">
                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(12) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(12) }}> Refresh</a>
                                    </div>
                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(APIServiceListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {APIServiceListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(APIServiceListing.length === 0) && <div className="alert alert-info" >No APIService Log to display  </div>}

                                        {
                                            (() => {
                                                if (APIServiceCount && APIServiceCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 12 } })} totalRow={APIServiceCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>

                        {/* System */}
                        <div className="box mt">
                            <div className="box-header well p0 pt prs">
                                <h2 className="ws-12 m0 pl full-width">
                                    <span className="pull-left cursor-hand" > System </span>
                                    <button className="icon-btn edit hover-box btn-xs pl pr pull-right p0 mr" onClick={() => { setsearchFor(""); System = !System; setSystem(System); apiCall(13) }}>
                                        <i className={System === false ? "icon-plus1" : "icon-minus1"}></i>
                                    </button>
                                </h2>
                            </div>

                            {System === true && <div className="box-content">
                                <div className="form-format ws-12">

                                    <div className="ws-6">
                                        <input className="p7 ws-6 heightReset border-green pull-left" id="Text1" name="searchFor" onChange={(e: any) => setsearchFor(e.target.value)} type="text" placeholder="Search Contract Management" />

                                        <a className="btn white bg-level7 text-center p8 m0 pull-left ws-2" onClick={() => { apiCall(13) }}>Search </a>
                                        <a className="btn white bg-level17 text-center p8 ml pull-left ws-2" onClick={() => { setsearchFor(""); apiCall(13) }}> Refresh</a>
                                    </div>



                                </div>
                                <br></br>
                                <div className="row-fluid">
                                    <div className="table-responsive">
                                        {(SystemListing.length > 0) && <table className="table bgWhite tablePresentation" >
                                            <thead>
                                                <tr>
                                                    <th>User</th>
                                                    <th>Description</th>
                                                    <th>Operation</th>
                                                    <th>Method</th>
                                                    <th>Date</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {SystemListing.map((value: any) => {
                                                    return (
                                                        <tr>
                                                            <td >{value.username}</td>
                                                            <td >{value.description}</td>
                                                            <td >{value.operation}</td>
                                                            <td >{value.method}</td>
                                                            <td >{value.date}</td>
                                                        </tr>)
                                                })}
                                            </tbody>
                                        </table>}

                                        {(SystemListing.length === 0) && <div className="alert alert-info" >No System Log to display  </div>}

                                        {
                                            (() => {
                                                if (SystemCount && SystemCount > 10) {
                                                    return <div className="ptl"><Pagination onPageChange={(e: any) => handlecontractMgt({ ...e, ...{ indexType: 13 } })} totalRow={SystemCount} /></div>
                                                }
                                            })()
                                        }
                                    </div>
                                </div>
                            </div>}

                        </div>
                    </div>
                </div>
            </Modal>

        </div>

    )

}